module.exports = __webpack_public_path__ + "static/media/email-saved-template.aaae4aa4.png";